import axios from "axios";
import {
  trackSoundChartApiCall,
  extractSoundChartEndpoint,
} from "../utils/soundChartTracking";
import { store } from "../store";
import { stopImpersonation } from "../store/slices/authSlice";
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

const soundchartsApi = axios.create({
  baseURL: "https://customer.api.soundcharts.com/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_SNDCHARTS_API_KEY as string,
    "x-app-id": process.env.REACT_APP_SNDCHARTS_APP_ID as string,
  },
});

api.interceptors.request.use(
  (config) => {
    try {
      const authData = localStorage.getItem("auth");
      if (authData) {
        const auth = JSON.parse(authData);
        if (auth?.token) {
          config.headers.Authorization = `Bearer ${auth.token}`;
        }
      }
      return config;
    } catch (error) {
      console.error("Error parsing auth data:", error);
      return config;
    }
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      const isAuthPage = window.location.pathname.startsWith("/auth");
      if (!isAuthPage) {
        const authData = localStorage.getItem("auth");
        if(authData && JSON.parse(authData).user?.impersonated) {
          store.dispatch(stopImpersonation());
          window.location.href = "/dashboard";
         }
         else{
          // localStorage.removeItem("auth");
          window.location.href = "/auth/login";
         }
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Records one SoundCharts call against our usage tracking, from either interceptor branch.
 *
 * Only calls that still leave the browser reach here. Playlist placements are fetched by the
 * Cadence backend now, and it tracks its own requests server-side — routing those through here
 * too would double-count them.
 */
const trackSoundchartsCall = (url: string | undefined, isSucceeded: boolean) => {
  try {
    const authData = localStorage.getItem("auth");
    if (!authData || !url) return;

    const auth = JSON.parse(authData);
    const email = auth?.user?.email || null;
    if (!email) return;

    const fullUrl = url.startsWith("http")
      ? url
      : `https://customer.api.soundcharts.com/api${url}`;

    trackSoundChartApiCall(
      extractSoundChartEndpoint(fullUrl),
      email,
      auth?.user?.labelName || null,
      isSucceeded
    );
  } catch (error) {
    // Tracking is bookkeeping: never let it change what the caller sees.
    console.error("SoundCharts tracking failed:", error);
  }
};

// SoundCharts API interceptor - automatic tracking
soundchartsApi.interceptors.response.use(
  (response) => {
    trackSoundchartsCall(response.config.url, true);
    return response;
  },
  (error) => {
    trackSoundchartsCall(error.config?.url, false);
    return Promise.reject(error);
  }
);

export { api, soundchartsApi };
